import { useApi_multipart } from '~/composables/useApi_multipart';
import { appendCsrfToFormData, appendCsrfToUrlSearchParams } from '~/composables/useCsrfToken';

export const useSettingsApi = () => {
  const updateEvalCycleName = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/updateEvalCycleName.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const deleteEvalCycle = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/deleteEvalCycle.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const updateEvalCycleOrder = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/updateEvalCycleOrder.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const selectEvalBaseData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectEvalBaseData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const selectEvalData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectEvalData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  /** QuickEdit용 데이터 조회 (등급/성과항목/역량항목만 부분 갱신) */
  const selectQuickEditData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectQuickEditData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 역량항목그룹 변경 시 역량 구분 목록(공통역량, 리더십 역량 등) 조회 */
  const selectChgCapaGbnList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectChgCapaGbnList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const saveInsaDataSet = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/saveInsaDataSet.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const getTargetMngData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectTargetMngData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const insertTargetMngData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/insertTargetMngData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const getUserInsaAllList = (params: URLSearchParams) => {
    return useApi('/api/common/userInsaAllList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const getDeptInsaList = (params: URLSearchParams) => {
    return useApi('/api/common/beingDeptInsaList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const getInsaCodeList = (params: URLSearchParams) => {
    return useApi('/api/common/insaCodeList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const getHisMonData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectHisMonData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const selectUserData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectUserData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /**
   * 평가군별 평가대상 현황 (레거시 hreConfMngList.jsp step06Mtd().getTargetList → selectTargetStatusList_json.do)
   */
  const selectTargetStatusList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectTargetStatusList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /**
   * Step07 평가대상 추가 팝업 인사 목록 (레거시 hreConfMngList.jsp openEvalTargetPop / getEvalTargetPop → selectGrpInsaUserList_json.do)
   */
  const selectGrpInsaUserList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectGrpInsaUserList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /**
   * Step07 평가군 대상자 추가 저장 (레거시 hreConfMngList.jsp addEvalTargetPop → addGrpUser.do)
   */
  const addGrpUser = (params: URLSearchParams) => {
    const p = new URLSearchParams(params.toString());
    appendCsrfToUrlSearchParams(p);
    return useApi('/api/hre/conf/hreConfMng/addGrpUser.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: p.toString(),
    });
  };

  /**
   * Step07 평가군 대상자 제외 (레거시 hreConfMngList.jsp deleteUserData → deleteGrpUserData.do)
   */
  const deleteGrpUserData = (formData: FormData) => {
    appendCsrfToFormData(formData);
    return useApi('/api/hre/conf/hreConfMng/deleteGrpUserData.do', {
      method: 'POST',
      body: formData,
      headers: {},
    });
  };

  const saveUserData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/saveUserData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const deleteInsaUserData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/deleteEvalTarget.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const selectInsaNewUserList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectInsaNewUserList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const selectInsaDeptList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectInsaDeptList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const saveInsaDeptList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/saveInsaDeptList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const saveInsaNewUserData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/saveInsaNewUserData.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const insertInsaData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/insertInsaData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const updateInsaData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/updateInsaData.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const selectEvalSetSummary = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectEvalSetSummary.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const selectYearEvalCycleList = (params: URLSearchParams) => {
    return useApi('/api/common/selectYearEvalCycleList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const copyEvalCycleSet = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/copyEvalCycleSet.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const saveTemplateEvalSet = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/saveTemplateEvalSet.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const saveEvalCycle = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/saveEvalCycle.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 평가군 목록 조회 (evalGrpId/evalGrpNm 포함) */
  const selectEvalGrpList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectEvalGrpList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 평가군별 대상자 배정 (직위/직급/직무/부서/직원 기준으로 그룹에 사용자 생성) */
  const createGrpUser = (formData: FormData) => {
    return useApi_multipart('/api/hre/conf/hreConfMng/createGrpUser.do', {
      method: 'POST',
      body: formData,
      headers: {},
    });
  };

  /** 평가설정 저장 (기본/단위/평가군/평가레벨 등 FormData 일괄 전송) */
  const saveEvalSetData = (formData: FormData) => {
    return useApi_multipart('/api/hre/conf/hreConfMng/saveEvalData_json.do', {
      method: 'POST',
      body: formData,
      headers: {},
    });
  };

  /**
   * 평가대상자 엑셀 업로드 전 인사부서 설정 여부 (레거시 hreConfMngList.jsp popEvalTargetExcelUploadForm → selectInsaDeptSetYn.do)
   */
  const selectInsaDeptSetYn = (params: URLSearchParams) => {
    const p = new URLSearchParams(params.toString());
    appendCsrfToUrlSearchParams(p);
    return useApi('/api/hre/conf/hreConfMng/selectInsaDeptSetYn.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: p.toString(),
    });
  };

  /** Step07 평가자 설정 (레거시 evaluatorConfigData.do) */
  const fetchEvaluatorConfigData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/evaluatorConfigData.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** Step07 일괄·단일 평가대상 설정 조회 (레거시 JSP: /hre/conf/hreTargetMng/evalTargetConfigForAdmin.do — hreConfMng 경로와 응답 스키마가 다름) */
  const fetchEvalTargetConfigForAdmin = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/evalTargetConfigForAdmin.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /**
   * 역량 구분별 역량 항목 목록 (레거시 hreConfMng selectGbnItemData_json.do — 역량평가 구분별 항목 팝업)
   * 파라미터: findYear, evalCycleCd, evalGrpId, capaGbnId, cmptGrpId(선택) 등 서버 스펙에 맞게 전달
   */
  const fetchGbnItemDataJson = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/selectGbnItemData_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /**
   * 평가대상자별 역량 항목 팝업 (레거시 hreConfMngList.jsp openCapaItem → capaItemList.do)
   * 파라미터: findYear, evalCycleCd, capaGbnId, evalTargetId
   */
  const fetchCapaItemList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/capaItemList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /**
   * 일괄설정 역량 항목 팝업 (레거시 hreConfMngList.jsp openCapaItemAll → capaItemAllList.do)
   * 파라미터: findYear, evalCycleCd, capaGbnId
   */
  const fetchCapaItemAllList = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/capaItemAllList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 동료/부하 평가자 일괄 생성 (레거시 evaluatorCreate.do) — 즉시 DB 저장 */
  const fetchEvaluatorCreate = (params: URLSearchParams) => {
    const p = new URLSearchParams(params.toString());
    appendCsrfToUrlSearchParams(p);
    return useApi('/api/hre/conf/hreConfMng/evaluatorCreate.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: p.toString(),
    });
  };

  /** 평가자 생성 미리보기 (DB 미저장) */
  const fetchEvaluatorCreatePreview = (params: URLSearchParams) => {
    const p = new URLSearchParams(params.toString());
    appendCsrfToUrlSearchParams(p);
    return useApi('/api/hre/conf/hreConfMng/evaluatorCreatePreview.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: p.toString(),
    });
  };

  /** 평가자 생성 조건(조직/직위/직급/인원)만 저장 */
  const fetchEvaluatorCreateConfig = (params: URLSearchParams) => {
    const p = new URLSearchParams(params.toString());
    appendCsrfToUrlSearchParams(p);
    return useApi('/api/hre/conf/hreConfMng/evaluatorCreateConfig.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: p.toString(),
    });
  };

  /** 역량항목 일괄 생성 (레거시 hreTargetMng/capaAllCreate.do) */
  const fetchCapaAllCreate = (formData: FormData) => {
    appendCsrfToFormData(formData);
    return useApi_multipart('/api/hre/conf/hreTargetMng/capaAllCreate.do', {
      method: 'POST',
      body: formData,
      headers: {},
    });
  };

  /** Step07 일괄설정 저장 (레거시 saveEvalTargetConfAll → saveEvalTargetAllForAdmin.do) */
  const saveEvalTargetAllForAdmin = (formData: FormData) => {
    appendCsrfToFormData(formData);
    return useApi_multipart('/api/hre/conf/hreTargetMng/saveEvalTargetAllForAdmin.do', {
      method: 'POST',
      body: formData,
      headers: {},
    });
  };

  /** Step07 상대평가 평가배분표 조회 (레거시 evalDistriMngData.do) */
  const fetchEvalDistriMngData = (params: URLSearchParams) => {
    return useApi('/api/hre/conf/hreConfMng/evalDistriMngData.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 평가배분표 엑셀 업로드 (레거시 saveEvalDistriMngExcelUpload.do) */
  const saveEvalDistriMngExcelUpload = (formData: FormData) => {
    appendCsrfToFormData(formData);
    return useApi_multipart('/api/hre/conf/hreConfMng/saveEvalDistriMngExcelUpload.do', {
      method: 'POST',
      body: formData,
      headers: {},
    });
  };

  /**
   * 평가대상자 엑셀 일괄 업로드 (레거시 popEvalTargetExcelUploadForm 제출)
   */
  const saveEvalTargetExcelUpload = (formData: FormData) => {
    appendCsrfToFormData(formData);
    return useApi_multipart('/api/hre/conf/hreConfMng/popEvalTargetExcelUpload.do', {
      method: 'POST',
      body: formData,
      headers: {
        'Html-Tag-Escape': 'N',
      },
    });
  };

  /**
   * 평가자 엑셀 일괄 업로드 (레거시 popEvaluatorExcelUploadForm 제출)
   */
  const saveEvaluatorExcelUpload = (formData: FormData) => {
    appendCsrfToFormData(formData);
    return useApi_multipart('/api/hre/conf/hreConfMng/popEvaluatorExcelUpload.do', {
      method: 'POST',
      body: formData,
      headers: {
        'Html-Tag-Escape': 'N',
      },
    });
  };

  return {
    updateEvalCycleName,
    deleteEvalCycle,
    updateEvalCycleOrder,
    selectEvalBaseData,
    selectEvalData,
    selectQuickEditData,
    selectChgCapaGbnList,
    saveInsaDataSet,
    getTargetMngData,
    insertTargetMngData,
    getUserInsaAllList,
    getDeptInsaList,
    getInsaCodeList,
    getHisMonData,
    selectUserData,
    selectTargetStatusList,
    selectGrpInsaUserList,
    addGrpUser,
    deleteGrpUserData,
    saveUserData,
    deleteInsaUserData,
    selectInsaNewUserList,
    selectInsaDeptList,
    saveInsaDeptList,
    saveInsaNewUserData,
    insertInsaData,
    updateInsaData,
    selectEvalSetSummary,
    selectYearEvalCycleList,
    copyEvalCycleSet,
    saveTemplateEvalSet,
    saveEvalCycle,
    selectEvalGrpList,
    createGrpUser,
    saveEvalSetData,
    selectInsaDeptSetYn,
    fetchEvaluatorConfigData,
    fetchEvalTargetConfigForAdmin,
    fetchGbnItemDataJson,
    fetchCapaItemList,
    fetchCapaItemAllList,
    fetchEvaluatorCreate,
    fetchEvaluatorCreatePreview,
    fetchEvaluatorCreateConfig,
    fetchCapaAllCreate,
    saveEvalTargetAllForAdmin,
    fetchEvalDistriMngData,
    saveEvalDistriMngExcelUpload,
    saveEvalTargetExcelUpload,
    saveEvaluatorExcelUpload,
  };
};
